const LocalStorageKey = {
    LANGUAGE: "language",
    TOKEN: "token",
    USER_DATA: "userData"
}

export default LocalStorageKey;
